<template>
  <v-container class="d-flex justify-center" style="height:440px;">
    <v-carousel cycle light hide-delimiters class="d-flex justify-center">
      <v-carousel-item
        v-for="(data, i) in dataArray"
        :key="i"
        class="chart-cycle-item"
      >
        <v-sheet>
          <v-row class="fill-height" align="center" justify="center">
            <slot :data="data" />
          </v-row>
        </v-sheet>
      </v-carousel-item>
    </v-carousel>
  </v-container>
</template>
<script>
export default {
  props: ['dataArray'],
};
</script>
